export default __webpack_public_path__ + "static/media/mparticle.a6d81d54.svg";